export const SEEK_SIGNAL = 'seek';

export const PAUSE_SIGNAL = 'pause';

export const TIME_ASIDE = 'aside';

export const TIME_BELOW = 'below';

export const TIME_HIDDEN = 'hidden';

export const PAUSE_ON_LONG_SEEK = false;
